import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-试油跟踪_试油概览实时曲线",
  "use": "icon-试油跟踪_试油概览实时曲线-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-试油跟踪_试油概览实时曲线\">\n<polygon points=\"15.9,15.3 0.1,15.3 0.1,0.7 1.2,0.7 1.2,14.3 15.9,14.3 \" />\n<path d=\"M9.8,11.6L4.9,6.1l-4,3.1C0.7,9.4,0.5,9.3,0.4,9.2C0.2,9,0.3,8.8,0.4,8.7L5,5.1l4.8,5.3l5.2-5.8c0.4-0.5,1,0,0.6,0.5\n\tL9.8,11.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol